// When the app renders the public (unauthenticated) travel diary, in-render
// fetches deep inside @koob/trip-export still go through the regular api
// modules. Setting the share token here reroutes them to the public
// /travel-diaries endpoints instead of the authenticated ones.
let publicShareToken = null;

export const setPublicShareToken = token => {
  publicShareToken = token;
};

export const getPublicShareToken = () => publicShareToken;
